import http from '../jslibs/axios/http';

//合作伙伴 获取列表
export  const getPartnerList = () => (http.get('/v1/cms/CooperativePartner'));

//合作伙伴 获取伙伴详情
export  const getPartnerDetail = uuid => (http.get(`/v1/cms/CooperativePartner/${uuid}`))

//合作伙伴 新增合作伙伴
export  const addPartner = data => (http.post('/v1/cms/CooperativePartner', data))

//合作伙伴 编辑合作伙伴
export  const editPartner = data => (http.put(`/v1/cms/CooperativePartner/${data.id}`, data))

//合作伙伴 删除合作伙伴
export  const deletePartner = uuid => (http.delete(`/v1/cms/CooperativePartner/${uuid}`))